import React, { useEffect, useRef, useState } from 'react';
import styles from './AdminMobileProductRegister.module.css';
import { textFormat } from "InitialData/regExp";
import { mainBgColor, mainPadd, mainPadd2, pageCommonGap1, pageCommonPadd2, pageH1FontSize, registerFontSize, registerGap1, registerGap2, registerHeight } from 'routes/adminMobile/constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import InputImage from 'components/inputs/image/InputImage';
import InputText from 'components/inputs/signUp/InputText';
import { validateInputs } from 'shared/utils/Utils';
import { toast } from "react-toastify";
import AdminMobileToggleBtn from '../components/common/AdminMobileToggleBtn';
import { requester } from 'App';
import { CFormSelect } from '@coreui/react';
import QuillEditor from 'components/inputs/richEditor/QuillEditor';

const AdminMobileProductRegister = () => {
    const inputs = useRef([]);
    const [isMounted, setMounted] = useState(false);
    const [product, setProduct] = useState();
    const [categories, setCategories] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const [isOn, setIsOn] = useState(false); // 토글 버튼 상태 관리
    const {moveToBack} = useCustomAdminMobileMove();

    let data = {
        storeId: "root",
        productImg: "",
        productName: "",
        price: "",
        productSaleOn: false,
        productReserveStart: "",
        productReserveEnd: "",
        categoryId: selectedCategory === "" ? null : selectedCategory,
        productExpDate: "",
        productDetailPage1: "",
        productDetailPage2: "",
    };

    // 토글 버튼으로부터 isOn 상태를 받아 업데이트
    const handleToggle = (newIsOn) => {
        setIsOn(newIsOn);
        
    };

    useEffect(()=> {
        setMounted(true);
    }, []);

    // 카테고리 데이터 가져오기
    useEffect(() => {
        if (isMounted) {
            let data = { storeId: "root" }
            requester.findAllCategories(data, (result) => {
                const filteredCategories = result.data.filter(category => category.parentCategoryId != null);
                //
                setCategories(filteredCategories);
            })
        }
    }, [isMounted]);
    //

    const handleSelectChange = (event) => {
        // 여기에서 선택된 카테고리의 ID를 사용할 수 있습니다.
        
        setSelectedCategory(event.target.value);
    };

    // 상품 등록 버튼 클릭 함수
    const onClick = () => {
        // 판매 설정 on/off
        data.productSaleOn = isOn;
        

        // 초기화 된 데이터
        

        validateInputs(inputs.current).then((result) => {
            if(result.isValid) {
                data.productImg = inputs.current[0].getValue();
                data.productName = inputs.current[1].getValue();
                data.price = inputs.current[2].getValue();
                data.productReserveStart = inputs.current[3].getValue();
                data.productReserveEnd = inputs.current[4].getValue();
                data.productExpDate = inputs.current[5].getValue();
                data.productDetailPage1 = inputs.current[6].getValue();
                data.productDetailPage2 = inputs.current[7].getValue();

                // validate 이후 데이터 확인
                
            }else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    return (
        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' />
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>상품 등록</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <AdminMobileContentBox>
                        <VerticalFlex gap={registerGap1}>
                            <FlexChild>
                                <VerticalFlex gap={registerGap1}>
                                    <FlexChild>
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>상품 정보 입력</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputImage ref={el => (inputs.current[0] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={product && product.image ? product.image : ""} maxSizeMb={1} />
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"상품명 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                            <FlexChild alignItems="flex-start">
                                                <InputText ref={el => (inputs.current[2] = el)} placeHolder={"상품가격 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={registerFontSize}>판매설정</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end">
                                        <AdminMobileToggleBtn onToggle={handleToggle} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>판매예약</P>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[3] = el)} placeHolder={"예약 시작일 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                            <FlexChild width="auto">
                                                <P>-</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[4] = el)} placeHolder={"예약 종료일 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <AdminMobileContentBox>
                        <VerticalFlex gap={registerGap1}>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>카테고리 선택</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <CFormSelect onChange={handleSelectChange}>
                                            <option value={""}>선택하세요</option>
                                            {categories && categories.map((category) => (
                                                <option key={category.id} value={category.id}>
                                                    {category.categoryName}
                                                </option>
                                            ))}
                                        </CFormSelect>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>유통기한</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <InputText ref={el => (inputs.current[5] = el)} placeHolder={"유통기한 입력"} regExp={[textFormat]} />
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
                <FlexChild>
                    {/* QuillEditor 높이 잡아야 함 */}
                    <VerticalFlex backgroundColor={mainBgColor} padding={mainPadd2} gap={"1.5rem"}>
                        <FlexChild>
                            <AdminMobileContentBox flexStart>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>상세 페이지 등록</P>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <QuillEditor ref={el => (inputs.current[6] = el)} name={"상세 페이지 등록 1"} value={product && product.content ? product.content : ""} path={"product/" + "product.id"} preview={false} />
                                            </FlexChild>
                                            <FlexChild>
                                                <QuillEditor ref={el => (inputs.current[7] = el)} name={"상세 페이지 등록 1"} value={product && product.content ? product.content : ""} path={"product/" + "product.id"} preview={false} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </AdminMobileContentBox>
                        </FlexChild>
                        <FlexChild height="initial">
                            <div className={styles.regiBtn} onClick={onClick}>
                                <span>상품 등록</span>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileProductRegister;